<template>

	<div class="c-form-duplicate">

		<h6 class="c-text-icon margin-t-24 margin-b-16">
			{{title}}
			<svg @click="deleteUser" class="c-form-duplicate__delete color-gray-600 margin-l-8" width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M9 11c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1v-4c0-.55.45-1 1-1Zm6 0c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1v-4c0-.55.45-1 1-1Zm3 8c0 .551-.448 1-1 1H7c-.552 0-1-.449-1-1V8h12v11ZM10 4.328c0-.155.214-.328.5-.328h3c.286 0 .5.173.5.328V6h-4V4.328ZM21 6h-5V4.328C16 3.044 14.879 2 13.5 2h-3C9.121 2 8 3.044 8 4.328V6H3c-.55 0-1 .45-1 1s.45 1 1 1h1v11c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3V8h1c.55 0 1-.45 1-1s-.45-1-1-1Z" id="trash"/></defs><use fill="currentColor" fill-rule="nonzero" xlink:href="#trash"/></svg>
		</h6>

		<c-input
			:label="'Voornaam'"
			:horizontal="true"
			type="text"
			name="first_name"
			v-model="formData.first_name"
			:required="true"/>

		<c-input
			:label="'Achternaam'"
			:horizontal="true"
			type="text"
			name="last_name"
			v-model="formData.last_name"
			:required="true"/>

		<c-input
			:label="'Functie'"
			:horizontal="true"
			type="text"
			name="title"
			v-model="formData.title" />

		<c-input
			:label="'Telefoonnummer'"
			:horizontal="true"
			type="phone"
			name="phone"
			min="0"
			v-model="formData.phone"
			:required="true"/>

		<c-input
			:label="'E-mailadres'"
			:horizontal="true"
			type="email"
			name="email"
			v-model="formData.email"
			:required="true"/>

		<c-radiogroup v-if="!without_account"
			:options="[
				{value: true, label:'Ja'},
				{value: false, label:'Nee'},
			]"
			:horizontal="true"
			:label="'Account aanmaken?'"
			:name="'has_account'"
			v-model="formData.has_account"
			:required="true"/>
	</div>

</template>

<script>
import Form from '@mixins/Form';

export default {
	mixins: [Form],
	data() {
		return {
            formData: this.contact,
		}
	},
	props: {
		edit: {
			required: false
		},
		contact: {
			required: false
		},
		title: {
			required: false,
			default: 'Persoonsgegevens'
		},
		without_account: {
			required: false,
			default: false
		}
	},
	emits: ['delete-user'],
	methods: {
		deleteUser () {
			this.$emit('delete-user');
		},
		getData() {

			let personalData = {... this.formData};

            if (this.edit) {
                personalData.id = this.contact.id;
            }

			if(this.without_account){
				personalData.has_account = false;
			}

			return personalData;
		},
		clearData(){
			this.formData = {
				first_name: '',
				last_name: '',
				title: '',
				phone: '',
				email: '',
				has_account: false,
			}
		},
        setData(data){
			Object.keys(data).forEach(key => {
                this.formData[key] = data[key];
            });
        }
	},
    watch:{
        edit(value){
            if(value && this.contact){
                this.setData(this.contact)
            }
        },
        contact(value){
            if(value && this.edit){
                this.setData(this.contact)
            }
        }
    }
}
</script>
